export function getNextAction(status) {
    switch (status) {
        case 'created':
            return 'Schedule migration';
        case 'migrationScheduling':
            return 'Awaiting migration start';
        case 'migrationScheduleFailed':
            return 'Retry migration schedule';
        case 'migrationStarted':
            return 'Await migration, then trigger validation';
        case 'migrationCompleted':
            return 'Schedule validation';
        case 'validationScheduling':
            return 'Awaiting validation start';
        case 'validationScheduleFailed':
            return 'Retry validation schedule';
        case 'validationStarted':
            return 'Await validation, rollback if failed';
        case 'validationCompleted':
            return 'Review & close';
        case 'rollbackStarted':
            return 'Awaiting rollback completion';
        case 'rollbackSuccess':
            return 'Review and close';
        case 'rollbackFailed':
            return 'Retry rollback';
        default:
            return 'Review batch';
    }
}
